import { useQuery } from '@tanstack/react-query';
import { aiApi } from '../../api/ai';

interface SentimentBadgeProps {
  text: string;
  className?: string;
}

const SENTIMENT_COLORS: Record<string, string> = {
  positive: 'var(--scpa-status-ok)',
  neutral: 'var(--scpa-text-muted)',
  frustrated: 'var(--scpa-status-warning)',
  urgent: 'var(--scpa-status-error)',
};

export default function SentimentBadge({ text, className = '' }: SentimentBadgeProps) {
  const { data: sentiment, isLoading } = useQuery({
    queryKey: ['sentiment', text?.slice(0, 200)],
    queryFn: () => aiApi.sentiment(text),
    enabled: !!text && text.length > 20,
    staleTime: 5 * 60 * 1000,
  });

  if (!text || text.length < 20 || isLoading || !sentiment) return null;

  const color = SENTIMENT_COLORS[sentiment] ?? SENTIMENT_COLORS.neutral;

  return (
    <span
      className={`inline-flex items-center capitalize ${className}`}
      style={{ color, fontSize: 12, fontWeight: 700 }}
      title="AI-detected sentiment"
    >
      {sentiment}
    </span>
  );
}
